import {
  ChannelEventType,
  useChannelEvents,
} from "@/composables/channel-events";
import { useUserStore } from "@/stores/user.store";
import { ref } from "vue";

export function useAuthForAction<T extends readonly unknown[]>(
  action: (...params: [...T]) => void,
) {
  const isAuthenticating = ref(false);
  const userStore = useUserStore();

  const { emitChannelEvent } = useChannelEvents();

  return (...params: [...T]) => {
    if (userStore.isAuthenticated) {
      action(...params);
    } else {
      isAuthenticating.value = true;
      emitChannelEvent({
        type: ChannelEventType.SHOW_AUTH_MODAL,
      });
    }
  };
}
